import type { Sentiments } from '@engagement-web-app/common';

/** Compact form for the list, where the column is icon-only. */
export const SENTIMENT_EMOJI: Record<Sentiments, string> = {
    ANGER: '😠',
    FEAR: '😨',
    SADNESS: '😣',
    JOY: '☺️',
    NEUTRAL: '😶',
};

export const SENTIMENT_TEXT: Record<Sentiments, string> = {
    ANGER: '怒り',
    FEAR: '不安',
    SADNESS: '悲しみ',
    JOY: '喜び',
    NEUTRAL: '中立',
};

/** Emoji + word, for pickers where the icon alone is ambiguous. */
export function sentimentLabel(sentiment: Sentiments): string {
    return `${SENTIMENT_EMOJI[sentiment]} ${SENTIMENT_TEXT[sentiment]}`;
}
